/** F&CO 신제품 발주(202)·운영제품 재발주(203) — EAS 요청번호만 품의에 연결, 본문은 일반 에디터 */
export const FNCO_PRODUCT_PURCHASE_TYPES: number[] = [202, 203];

export const isFncoProductPurchaseType = (apvType: number): boolean =>
  FNCO_PRODUCT_PURCHASE_TYPES.includes(apvType);

/** EAS → 작성 화면 진입 쿼리 키 — 레거시 `/intranet/approval/create?apv_type=203&reqno=` 와 동일 */
export const FNCO_PRODUCT_PURCHASE_ENTRY_QUERY_KEY = 'reqno';

export const FNCO_PRODUCT_PURCHASE_MISSING_MESSAGE =
  '데이터의 request number가 존재하지 않습니다. reqno를 다시 확인해주세요.';

/** 진입 쿼리 → 요청번호. 반복 키는 첫 값, 공백만 있으면 없음 */
export const getFncoProductPurchaseEntryRequestNumber = (
  query: Record<string, string | string[] | undefined>,
): string | undefined => {
  const raw = query[FNCO_PRODUCT_PURCHASE_ENTRY_QUERY_KEY];
  const value = (Array.isArray(raw) ? raw[0] : raw)?.trim();
  return value || undefined;
};

/** 저장 attributes → 요청번호. 레거시 문서(VC001 없음)는 attributes 가 null */
export const parseFncoProductPurchaseRequestNumber = (
  attributes: Record<string, unknown> | null | undefined,
): string | null => {
  const value = attributes?.requestNumber;
  return typeof value === 'string' && value.trim() ? value.trim() : null;
};

export const buildFncoProductPurchaseAttributes = (
  requestNumber: string | null,
) => (requestNumber ? { requestNumber } : null);
